export const PURCHASING_PRODUCT_REQUEST = 'purchasing/request';
export const PURCHASING_PRODUCT_SUCCESS = 'purchasing/success';
export const PURCHASING_PRODUCT_FAILURE = 'purchasing/failure';

export const PURCHASING_SET_DATERANGE_FILTERS_SUCCESS = 'purchasing/action/set-daterange-filters/success';
export const PURCHASING_FILTERS_CLEAR = 'purchasing/filters/success';
